
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ImageAsDataUrlRenderer extends Vue {
    @Prop({ type: String, required: false, default: '' })
    public readonly alt!: string;

    @Prop({ type: Object, required: false, default: () => ({}) })
    public readonly classes!: any;

    @Prop({ type: String, required: false, default: null })
    public readonly url!: string | null;

    public source: string | null = null;

    @Watch('url', { immediate: true })
    public onUrlUpdated(): void {
        const url = this.url;
        if (url !== null) {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.onload = () => {
                if (this.url === url) {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.naturalWidth;
                    canvas.height = image.naturalHeight;
                    const context = canvas.getContext('2d');
                    if (context) {
                        context.drawImage(image, 0, 0);
                    }
                    this.source = canvas.toDataURL('image/png');
                }
            };
            image.src = url;
        } else {
            this.source = null;
        }
    }
}
